import { Injectable, signal } from "@angular/core";
import { ModelBase } from "./modelBase";

@Injectable({
  providedIn: 'root',
})

export abstract class StoreBase<T extends ModelBase> {
  private signalModel = signal<T[]>([]);

  getModel = () => this.signalModel;

  setModel(model: T[]) {
    this.signalModel.set(model);
  }

  addModel(model: T) {
    this.signalModel.update((currentModels) => [...currentModels, model]);
  }

  removeModel(modelId: number) {
    //this.signalModel.update((currentModels) => currentModels.filter(model => model.id !== modelId));
  }
}
